import { ClientClient } from './ClientClient';
import { AgentClient } from './AgentClient';
import { AuthClient } from './AuthClient';
import { CarrierClient } from './CarrierClient';
import { DeveloperClient } from './DeveloperClient';
import { WebClientStorage } from './AbstractClient';
import { ClientSubmissionClient } from './ClientSubmissionClient';
import { CancelClient } from './CancelClient';
import { TrackingClient } from './TrackingClient';
import { ResyncRunClient } from './ResyncRunClient';

export class OwlClient {
  readonly client: ClientClient;
  readonly cancel: CancelClient;
  readonly agent: AgentClient;
  readonly auth: AuthClient;
  readonly carrier: CarrierClient;
  readonly developer: DeveloperClient;
  readonly clientSubmission: ClientSubmissionClient;
  readonly tracking: TrackingClient;
  readonly resyncRun: ResyncRunClient;

  constructor(baseUrl: string, storage: WebClientStorage) {
    this.client = new ClientClient(`${baseUrl}/client`, storage, true);
    this.cancel = new CancelClient(
      `${baseUrl}/client-policy-cancellation-request`,
      storage,
    );
    this.agent = new AgentClient(`${baseUrl}/agent`, storage);
    this.carrier = new CarrierClient(`${baseUrl}/carrier`, storage);
    this.developer = new DeveloperClient(`${baseUrl}/developer`, storage, true);
    this.auth = new AuthClient(baseUrl, storage, true);
    this.clientSubmission = new ClientSubmissionClient(
      `${baseUrl}/client-submission`,
      storage,
      true,
    );
    this.tracking = new TrackingClient(`${baseUrl}/tracking`, storage, false);
    this.resyncRun = new ResyncRunClient(
      `${baseUrl}/resync-runs`,
      storage,
      true,
    );
  }
}
